import { render, staticRenderFns } from "./SoloIcon.vue?vue&type=template&id=75b37b40&scoped=true"
import script from "./SoloIcon.vue?vue&type=script&lang=js"
export * from "./SoloIcon.vue?vue&type=script&lang=js"
import style0 from "./SoloIcon.vue?vue&type=style&index=0&id=75b37b40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b37b40",
  null
  
)

export default component.exports